import { Outlet } from 'react-router-dom';
import { Rail } from './rail/Rail';
import { AudioPlayerNavigation } from './player/AudioPlayerNavigation';
import './Layout.css';

/**
 * Persistent app shell: rail and now-playing sidebar are rendered once here
 * and never unmount on navigation - only the routed page (via Outlet) swaps.
 * Each page renders its own .pageHeader/.pageContent directly.
 */
export function Layout(): React.JSX.Element {
    return (
        <div className="pageContainer">
            <div className="pageRail">
                <Rail />
            </div>
            <div className="pageMain">
                <Outlet />
            </div>
            <div className="pageNowPlaying">
                <AudioPlayerNavigation />
            </div>
        </div>
    );
}
